import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PRICING_PROFILE_DATE_RANGE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import NewPricingProfileDateRangeForm from './NewPricingProfileDateRangeForm';
import { postPricingProfileDateRange } from '../../../../actions/sales/PricingProfileDateRange';
import { tzNormalizeDate } from '../../../../utils/date';

const NewPricingProfileDateRange = ({
  breadcrumbs,
  dispatchPostPricingProfileDateRange,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    newFormValues.pricingProfileDateRangeList = Array.isArray(
      formValues.pricingProfileDateRangeList,
    )
      ? formValues.pricingProfileDateRangeList.map(
          ({ startDate, endDate, reason }) => ({
            startDate: startDate ? tzNormalizeDate({ date: startDate }) : null,
            endDate: endDate ? tzNormalizeDate({ date: endDate }) : null,
            reason,
          }),
        )
      : [];

    dispatchPostPricingProfileDateRange(newFormValues);
  };

  const content = <NewPricingProfileDateRangeForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Registrar Rango de Fechas Para Perfil de Precios"
      subtitle="Registra rango de fechas para perfiles de precios"
      content={content}
    />
  );
};

NewPricingProfileDateRange.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostPricingProfileDateRange: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostPricingProfileDateRange: postPricingProfileDateRange,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Rango de Fechas para Perfiles de Precio',
      href: PRICING_PROFILE_DATE_RANGE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewPricingProfileDateRange);
